export const resolveUniqueFolderName = (
  desiredName: string,
  existingLabels: string[]
): string => {
  const checkLabel = (label: string) => existingLabels.includes(label)

  if (!checkLabel(desiredName)) return desiredName

  let count = 1

  while (existingLabels.includes(`${desiredName} (${count})`)) {
    count += 1
  }

  return `${desiredName} (${count})`
}
